<template>
    <ResourceInput
        label="Window title"
        attribute="windowTitle"
    />

    <ResourceInput
        label="Meta description"
        attribute="metaDescription"
        type="textarea"
    />

    <ResourceInput
        label="OG Data"
        attribute="ogData"
        type="textarea"
    />

    <ResourceInput
        label="No index"
        attribute="noIndex"
        type="boolean"
    />
</template>
